import { call, put, select, takeEvery } from "redux-saga/effects";
import { getRulesByDeviceId } from "../../api/RoiServiceManager";
import { fetchRulesListSuccess, fetchRulesListFailure, types } from "../actions";

const activeSession = (state) => state.sessionReducer.activeSession;

function* fetchRulesListSaga(action) {
  try {
    const session = yield select(activeSession);
    const payload = {
      accountname: session.activeSession.accountId,
      ...action.payload
    };
    const response = yield call(getRulesByDeviceId, payload);
    if (!response) {
      throw new Error("Failed to fetch rules");
    }
    yield put(fetchRulesListSuccess(response));
  } catch (error) {
    yield put(fetchRulesListFailure(error?.message || "Failed to fetch rules"));
    console.log("Error while fetching rules list -> " + error);
  }
}

function* AlertsSaga() {
  yield takeEvery(types.RULES_LIST_REQUEST, fetchRulesListSaga);
}

export default AlertsSaga;
